function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useContext } from "react";
import { LinkContext } from "../../../context";
import { Button } from "../Button";
import { LinkButton } from "../LinkButton";
export var CallToAction = function(_param) {
    var icon = _param.icon, href = _param.href, label = _param.label, target = _param.target, download = _param.download, className = _param.className, children = _param.children, subtle = _param.subtle, brandVariant = _param.brandVariant, linkVariant = _param.linkVariant, buttonVariant = _param.buttonVariant, props = _objectWithoutProperties(_param, [
        "icon",
        "href",
        "label",
        "target",
        "download",
        "className",
        "children",
        "subtle",
        "brandVariant",
        "linkVariant",
        "buttonVariant"
    ]);
    var LinkComponent = useContext(LinkContext).LinkComponent;
    if (props.style === "link" || !props.style) {
        return /*#__PURE__*/ React.createElement(LinkButton, {
            as: LinkComponent,
            subtle: subtle,
            variant: linkVariant !== null && linkVariant !== void 0 ? linkVariant : "default",
            icon: icon,
            href: href,
            target: target,
            download: download,
            theme: subtle ? "primary-light" : brandVariant === "secondary" ? "secondary" : "default",
            className: className
        }, label || children);
    }
    if (props.style === "button") {
        return /*#__PURE__*/ React.createElement(Button, {
            as: LinkComponent,
            variant: buttonVariant !== null && buttonVariant !== void 0 ? buttonVariant : "primary",
            theme: brandVariant === "secondary" ? "secondary" : "default",
            icon: icon,
            href: href,
            target: target,
            download: download,
            className: className
        }, children || label);
    }
    return null;
};

//# sourceMappingURL=CallToAction.js.map